import { CommonModule } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { PageContainerService } from '../../services/page-container.service';
import { ViewDetectionService } from '../../services/view-detection.service';
import { tap } from 'rxjs';
import { TopHeaderTabsComponent } from './top-header-tabs/top-header-tabs.component';
import { MobilePageTitleComponent } from './mobile-page-title/mobile-page-title.component';
import { TopHeaderRightSectionComponent } from './top-header-right-section/top-header-right-section.component';

@Component({
  selector: 'z-top-header',
  standalone: true,
  imports: [
    CommonModule,
    TopHeaderTabsComponent,
    TopHeaderRightSectionComponent,
    MobilePageTitleComponent,
  ],
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.scss'],
})
export class TopHeaderComponent {
  logoUrl = input.required<string>();
  isExpand = signal<boolean>(false);
  gridView$ = this.viewDetection.gridView;

  expandMenuDrawer$ = this.pageContainerService.expandMenuDrawer$.pipe(
    tap(x => {
      if (x) this.pageContainerService.expandFilterDrawer$.next(!x);
      if (x !== this.isExpand()) {
        this.isExpand.set(x);
      }
    }),
  );

  constructor(
    readonly viewDetection: ViewDetectionService,
    readonly pageContainerService: PageContainerService,
  ) {}

  expandDrawer() {
    this.isExpand.update(x => !x);
    this.pageContainerService.expandMenuDrawer$.next(this.isExpand());
  }
}
